export default __webpack_public_path__ + "static/media/EY.27cf4caf.png";